var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCustomize = function SvgCustomize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#777776"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.5833 8.83743h-10.99967c-.50415 0-.91664.43171-.91664.95936 0 .52761.41249.95931.91664.95931h10.99967c.5042 0 .9167-.4317.9167-.95931 0-.52765-.4125-.95936-.9167-.95936zm0-3.83743h-10.99967c-.50415 0-.91664.43171-.91664.95936 0 .52764.41249.95936.91664.95936h10.99967c.5042 0 .9167-.43172.9167-.95936 0-.52765-.4125-.95936-.9167-.95936zm-10.99967 9.5936h3.16646c.50415 0 .91664-.4317.91664-.9594 0-.5276-.41249-.9593-.91664-.9593h-3.16646c-.50415 0-.91664.4317-.91664.9593 0 .5277.41249.9594.91664.9594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2326 10.5729.0845.0872c.3663.3775.3663.9873 0 1.3648l-5.2402 5.4107c-.3663.3775-.9579.3775-1.3242 0l-2.90184-2.9909c-.36625-.3775-.36625-.9873 0-1.3648l.08452-.0871c.36626-.3775.9579-.3775 1.32412 0l2.16 2.2263 4.4889-4.6365c.3569-.3872.9579-.3872 1.3242-.0097z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customize.0942cda3.svg";
export { ForwardRef as ReactComponent };